export default __webpack_public_path__ + "static/media/abroad.ccac6957.svg";